import React from 'react';
import { ArrowRight, Check } from 'lucide-react';
import { HouseIllustration, OfficeIllustration } from './illustrations/Illustrations';
import { useBooking } from '../context/BookingContext';
import { useT } from '../i18n/LanguageContext';

const residentialLeft = ['Kitchen', 'Bathrooms', 'Bedrooms & Living Rooms', 'Windows', 'Extra Services'];
const residentialRight = ['Carpet', 'Seasonal', 'Move in/out', 'Post construction', 'Express'];
const commercialLeft = ['Office', 'Shops', 'Medical facilities', 'Factories', 'Restaurants'];
const commercialRight = ['Warehouses', 'Airports', 'Move in/out', 'Government facilities', 'Showrooms'];

const residentialLeftPT = ['Cozinha', 'Banheiros', 'Quartos & Salas', 'Janelas', 'Serviços Extras'];
const residentialRightPT = ['Carpete', 'Sazonal', 'Mudança', 'Pós-obra', 'Expresso'];
const commercialLeftPT = ['Escritório', 'Lojas', 'Clínicas', 'Fábricas', 'Restaurantes'];
const commercialRightPT = ['Galpões', 'Aeroportos', 'Mudança', 'Instituições', 'Showrooms'];

export default function Services() {
  const { openModal } = useBooking();
  const { t, lang } = useT();

  const services = [
    {
      id: 'residential',
      Illustration: HouseIllustration,
      kicker: t('svc.residential.kicker'),
      title: t('svc.residential.title'),
      desc: t('svc.residential.desc'),
      sub: t('svc.residential.sub'),
      left: lang === 'pt' ? residentialLeftPT : residentialLeft,
      right: lang === 'pt' ? residentialRightPT : residentialRight,
    },
    {
      id: 'commercial',
      Illustration: OfficeIllustration,
      kicker: t('svc.commercial.kicker'),
      title: t('svc.commercial.title'),
      desc: t('svc.commercial.desc'),
      sub: t('svc.commercial.sub'),
      left: lang === 'pt' ? commercialLeftPT : commercialLeft,
      right: lang === 'pt' ? commercialRightPT : commercialRight,
    },
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <p className="uc-kicker mb-3">{t('services.kicker')}</p>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#1a2851]">
            {t('services.heading1')} <span className="text-[#4dbfae]">{t('services.heading2')}</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
          {services.map((svc) => {
            const Illustration = svc.Illustration;
            return (
              <article key={svc.id} className="uc-lift bg-[#f7fcfb] rounded-2xl p-8 lg:p-10 border border-[#eef6f4]">
                <div className="w-full mb-6 flex items-center justify-center">
                  <Illustration className="w-full h-64" />
                </div>

                <h3 className="font-serif text-3xl md:text-4xl font-bold text-[#1a2851] mb-4">
                  <span className="text-[#4dbfae]">{svc.kicker}</span> {svc.title}
                </h3>
                <p className="text-[#5b6469] leading-relaxed mb-5">{svc.desc}</p>
                <p className="text-sm font-semibold text-[#1a2851] mb-4 uppercase tracking-wide">{svc.sub}</p>

                <div className="grid grid-cols-2 gap-3 mb-8">
                  <ul className="space-y-2">
                    {svc.left.map((it) => (
                      <li key={it} className="flex items-center gap-2 text-[#2b2e33]">
                        <Check size={16} className="text-[#4dbfae] shrink-0" />
                        <span className="text-sm">{it}</span>
                      </li>
                    ))}
                  </ul>
                  <ul className="space-y-2">
                    {svc.right.map((it) => (
                      <li key={it} className="flex items-center gap-2 text-[#2b2e33]">
                        <Check size={16} className="text-[#4dbfae] shrink-0" />
                        <span className="text-sm">{it}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <button onClick={openModal} className="uc-btn">
                  {t('svc.getEstimate')}
                  <ArrowRight size={18} />
                </button>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
